import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import PieChart from "../charts/generic/PieChart"

function GoalStatusBreakdown({ exportEndpoint, appliedFilters, data }) {
  const titleKey = "Widgets.GoalStatusBreakdown.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.GoalStatusBreakdown.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
    >
      <PieChart data={data} pluralTooltipDescriptorKey="Common.Goals" titleKey={titleKey}/>
    </Widget>
  )
}

GoalStatusBreakdown.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      itemName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ).isRequired,
  exportEndpoint: PropTypes.string.isRequired
}

export default GoalStatusBreakdown



// WEBPACK FOOTER //
// ./src/components/widgets/GoalStatusBreakdown.jsx